import React from 'react'
import './card.css'
import { IoIosPeople } from "react-icons/io";
import { BsCalendar2Week } from "react-icons/bs";
import { GiSandsOfTime } from 'react-icons/gi';


const Card = ({icon, text1, text2}) => {
    const Iconobj = {
        1 : <IoIosPeople id='card-icon-id'/>,
        2 : <BsCalendar2Week id='card-icon-id'/>,
        3 : <GiSandsOfTime id='card-icon-id'/>
    }
  return (
    <div className='card-container'>
        <span>{Iconobj[icon]}</span>
        <div className='card-container-div'>
            <span>{text1}</span>
            <span>{text2}</span>
        </div>
    </div>
  )
}

export default Card